export default __webpack_public_path__ + "static/cakery-round-1e4ea3da7dcc29edb5e17239cca4514b.svg";